import { createAction } from 'redux-actions'
import { getNextSourceSetupStep } from 'selectors'
import typewriter from 'analytics/typewriter'

export const RESET_SOURCE_SETUP = 'RESET_SOURCE_SETUP'
export const SET_SOURCE_SETUP_STEP = 'SET_SOURCE_SETUP_STEP'
export const UPDATE_SOURCE_SETUP_SOURCE = 'UPDATE_SOURCE_SETUP_SOURCE'

export const resetSourceSetup = createAction(RESET_SOURCE_SETUP)
export const setSourceSetupStep = createAction(SET_SOURCE_SETUP_STEP)
export const updateSourceSetupSource = createAction(UPDATE_SOURCE_SETUP_SOURCE)

export const nextSourceSetupStep = sourceMetadata => (dispatch, getState) => {
  const state = getState()
  const nextStep = getNextSourceSetupStep(state, sourceMetadata)
  dispatch(setSourceSetupStep(nextStep))
}

export const trackSourceAuthorizeClicked = ({
  workspace,
  sourceMetadata
}) => () => {
  typewriter.sourceAuthorizeClicked(
    {
      workspace_id: workspace.id,
      workspace_slug: workspace.slug,
      source_metadata_slug: sourceMetadata.slug,
      source_metadata_category: sourceMetadata.category,
      funnel_step: 'Source Authorize Clicked'
    },
    {
      context: {
        groupId: workspace.id
      }
    }
  )
}

export const trackSourceSetupFunnelStepCompleted = ({
  step,
  error,
  ctaText,
  sourceMetadata,
  workspace
}) => () => {
  const properties = {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_metadata_slug: sourceMetadata.slug,
    source_metadata_category: sourceMetadata.category,
    funnel_step: step,
    cta_text: ctaText
  }

  if (error) {
    properties.error_level = error.level
    properties.error_reason = error.reason
    properties.error_message = error.message
  }

  const options = {
    context: {
      groupId: workspace.id
    }
  }

  typewriter.sourceSetupFunnelStepCompleted(properties, options)
}
